<template>
  <div class="compressed-content">
    <h3 class="page-question">For females, do you have any of the following medical conditions?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.femaleConditions">
      <b-form-checkbox v-model="survey.medicalConditions.femaleConditions.noCondition" @change="onNoConditionSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.femaleConditions.hasEclampsia" @change="onEclampsiaSelected">
        History of preeclampsia or eclampsia
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.femaleConditions.hasEOM" @change="onEOMSelected">
        Menopause before age 40
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    data() {
      return {
        noCondition: false
      }
    },

    validations: {
      femaleConditions: {
        anyOptionRequired: anyOptionRequired((value) => value.noCondition || value.hasEclampsia || value.hasEOM)
      }
    },

    computed: {
      ...mapState(["survey"]),

      femaleConditions() { return this.survey.medicalConditions.femaleConditions; }
    },

    methods: {
      onNoConditionSelected(value) {
        this.setOptions(value, false, false);
      },

      onEclampsiaSelected(value) {
        this.setOptions(false, value, this.femaleConditions.hasEOM);
      },

      onEOMSelected(value) {
        this.setOptions(false, this.femaleConditions.hasEclampsia, value);
      },

      setOptions(noCondition, hasEclampsia, hasEOM) {
        this.survey.medicalConditions.femaleConditions.noCondition = noCondition;
        this.survey.medicalConditions.femaleConditions.hasEclampsia = hasEclampsia;
        this.survey.medicalConditions.femaleConditions.hasEOM = hasEOM;
      }
    }
  };
</script>